import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { useLocation, useParams } from "react-router-dom";
import { SendClientDispatchMailAPI } from "../../../../Redux/orders";
import { BtnLoader } from "../../../../../Components/Components";
import { Capacitor } from "@capacitor/core";
import { getCapacitorBaseUrl } from "../../../../../helpers/common";

const SendMailConfirmationModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ visible, setIsModalVisible }) => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const { sendDispatchMailLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  const onClose = () => {
    setIsModalVisible(false);
  };
  const onSubmit = () => {
    const payload = {
      order_id: id,
      link: Capacitor.isNativePlatform()
        ? getCapacitorBaseUrl(window?.location?.href)
        : window?.location?.href,
    };
    const handleSuccess = () => {
      setIsModalVisible(false);
    };
    dispatch(SendClientDispatchMailAPI(payload, handleSuccess));
  };
  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Installation Instruction Email Send to Client/Distributor, Are You
          Sure?
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={sendDispatchMailLoading}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-130"
            onClick={onSubmit}
            disabled={sendDispatchMailLoading}
          >
            {sendDispatchMailLoading ? <BtnLoader /> : "SEND EMAIL"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 mt-3 text-center text-4a4a4a">
          The installation instruction email will be sent to the client or
          distributor. Once sent, they will receive the necessary guidelines for
          installation.
        </p>
      </div>
    </Modal>
  );
};

export default SendMailConfirmationModal;
